import { sessionService } from 'redux-react-session';

export const API_BASE_URL = process.env.REACT_APP_API_URL;

export const HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  Token: '0d74b9f24c5a1cddfc1a7f1542796565',
  Secret: '1da5f16fd946d8eb86b0471542796565',
  'session-gi-active': '1',
  'API-apptype': 'web',
  crossDomain: true,
};

export const VALUES_SEPARATOR = '%-_-%';

export async function getHeaders() {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Token: '0d74b9f24c5a1cddfc1a7f1542796565',
    Secret: '1da5f16fd946d8eb86b0471542796565',
    'session-gi-active': '1',
    crossDomain: true,
    'API-apptype': 'web',
  };


  try {
    const user = await sessionService.loadUser();
    if (user && user.id) {
      headers['SESSION-GI'] = `${user.id}.${user.user_code}`;
    }
  } catch (e) {
    console.error(e);
  }

  return headers;
}



// WEBPACK FOOTER //
// ./src/constants/apiConf.js